module.exports = __webpack_public_path__ + "static/media/conexion_hexagono.b6fd0475.png";